export enum CouponIssueErrorCodes {
  NeedUserCertification = 'NeedUserCertification',
  NeedMarketingAgreement = 'NeedMarketingAgreement',
  ExpiredIssueDate = 'ExpiredIssueDate',
  MaximumIssueExceeded = 'MaximumIssueExceeded',
  MaximumIssueExceededPerUser = 'MaximumIssueExceededPerUser',
  InsufficientIssueRequirements = 'InsufficientIssueRequirements',
  InsufficientIssueRequirementsReply = 'InsufficientIssueRequirementsReply',
  InsufficientIssueRequirementsEpisodeRead = 'InsufficientIssueRequirementsEpisodeRead',
  AlreadyIssuePreviousCouponCatalog = 'AlreadyIssuePreviousCouponCatalog',
}
